import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon, Input } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { save } from "../../api/Promo"

/* Widgets */
import { toast } from "../common"

/* Shared */
import { TERMS, monthsText } from "./shared"

/* Moment */
import moment from "moment"

Modal.setAppElement("#root")


/* Widget Promo Form — a new promo code or a change of one. Opened by the reference:
   this._form.current.open() for a new one, this._form.current.open(promo) for a change.
   Props: onSaved */
class PromoForm extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            id: null,
            code: "",
            description: "",
            months: "1",
            maxUses: "",
            validUntil: "",
            active: true,
            usedCount: 0,
            saving: false
        }
    }

    open = (promo = null) => {

        if (promo) {
            this.setState({
                visible: true,
                id: promo.id,
                code: promo.code ? promo.code : "",
                description: promo.description ? promo.description : "",
                months: `${promo.months}`,
                maxUses: promo.maxUses === null || promo.maxUses === undefined ? "" : `${promo.maxUses}`,
                validUntil: promo.validUntil ? moment(promo.validUntil).format("YYYY-MM-DD") : "",
                active: !!promo.active,
                usedCount: promo.usedCount ? promo.usedCount : 0,
                saving: false
            })
        }
        else {
            this.setState({
                visible: true,
                id: null,
                code: "",
                description: "",
                months: "1",
                maxUses: "",
                validUntil: "",
                active: true,
                usedCount: 0,
                saving: false
            })
        }
    }

    close = () => {

        if (this.state.saving) {
            return
        }

        this.setState({ visible: false })
    }

    /* The code is typed the way the point will type it — Latin capitals, digits, a dash and an underscore */
    code = value => {
        this.setState({ code: `${value}`.toUpperCase().replace(/[^A-Z0-9_-]/g, "").slice(0, 64) })
    }

    digits = (field, value) => {
        this.setState({ [field]: `${value}`.replace(/\D/g, "").slice(0, 6) })
    }

    save = () => {

        /* Fields */
        const { id, code, description, months, maxUses, validUntil, active, saving } = this.state
        const { onSaved } = this.props

        if (saving) {
            return
        }

        let valid = true

        if (!/^[A-Z0-9_-]{3,64}$/.test(code)) {
            this._code.error("От 3 символов: латиница, цифры, «-» и «_»")
            valid = false
        }

        const term = parseInt(months)

        if (!term || term < 1 || term > 24) {
            this._months.error("От 1 до 24 месяцев")
            valid = false
        }

        if (maxUses.length > 0 && !(parseInt(maxUses) > 0)) {
            this._maxUses.error("Не меньше одного, пусто — без лимита")
            valid = false
        }

        if (!valid) {
            return
        }

        this.setState({ saving: true })

        save({ id, code, description: description.trim(), months: term, maxUses, validUntil, active }).then(response => {

            this.setState({ saving: false })

            if (response && response.status === 200) {
                toast.success(id ? "Сохранено" : "Промокод добавлен")
                this.setState({ visible: false })
                onSaved()
                return
            }

            const error = response && response.data ? response.data.code : null

            if (error === "CODE_TAKEN") {
                this._code.error("Такой промокод уже есть")
                return
            }

            if (error === "INVALID_CODE") {
                this._code.error("От 3 символов: латиница, цифры, «-» и «_»")
                return
            }

            if (error === "INVALID_MONTHS") {
                this._months.error("От 1 до 24 месяцев")
                return
            }

            if (error === "INVALID_LIMIT") {
                this._maxUses.error("Не меньше одного, пусто — без лимита")
                return
            }

            if (error === "INVALID_DATE") {
                toast.error("Неверная дата окончания")
                return
            }

            toast.error("Что-то пошло не так! Попробуйте позднее")
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Что-то пошло не так! Попробуйте позднее")
        })
    }

    render = () => {

        /* Fields */
        const { visible, id, code, description, months, maxUses, validUntil, active, usedCount, saving } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="wide-modal promo-form"
                overlayClassName="wide-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="wide-modal-header">
                    <h2>{id ? "Изменить промокод" : "Новый промокод"}</h2>
                    <div onClick={this.close} className="wide-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                {visible &&
                    <div className="wide-modal-body">

                        <div className="wide-modal-label">Код</div>
                        <div className="wide-modal-hint">
                            Точка вводит его при открытии в Bookify Pro. Латиница, цифры, «-» и «_», регистр не важен.
                            {id && usedCount > 0 ? " Точки, которые уже ввели код, сохранят свои месяцы при любой правке." : ""}
                        </div>
                        <Input ref={ref => this._code = ref} label="Промокод" maxLength={64} value={code} onChange={event => this.code(event.target.value)} />
                        <Input ref={ref => this._description = ref} label="Описание — для себя, точка его не видит" maxLength={255} value={description} onChange={event => this.setState({ description: event.target.value })} />

                        <div className="wide-modal-label">Бесплатно</div>

                        <div className="service-modal-durations">
                            {TERMS.map(term =>
                                <div key={`${term}`} onClick={() => this.setState({ months: `${term}` })} className={`service-modal-duration ${parseInt(months) === term ? "active" : ""}`}>
                                    {term} мес
                                </div>
                            )}
                        </div>

                        <Input ref={ref => this._months = ref} label="Месяцев подписки бесплатно (1–24)" value={months} onChange={event => this.digits("months", event.target.value)} />

                        <div className="wide-modal-label">Ограничения</div>

                        <Input ref={ref => this._maxUses = ref} label="Сколько точек может ввести — пусто без лимита" value={maxUses} onChange={event => this.digits("maxUses", event.target.value)} />

                        <div className="promo-form-date">
                            <div className="promo-form-date-text">
                                <b>Последний день</b>
                                <span>{validUntil ? `Код работает до конца ${moment(validUntil).format("D MMMM YYYY")}` : "Без срока — код работает, пока его не выключат"}</span>
                            </div>
                            <input type="date" value={validUntil} onChange={event => this.setState({ validUntil: event.target.value })} />
                            {validUntil.length > 0 &&
                                <div onClick={() => this.setState({ validUntil: "" })} className="promo-form-date-clear" title="Без срока">
                                    <Icon name="close" size={10} width={2.4} />
                                </div>
                            }
                        </div>

                        <div className="wide-modal-label">Состояние</div>

                        <div onClick={() => this.setState({ active: !active })} className={`service-modal-active ${active ? "on" : ""}`}>
                            <div className="service-modal-active-text">
                                <b>{active ? "Промокод включён" : "Промокод выключен"}</b>
                                <span>{active ? `Точка получит ${monthsText(parseInt(months) || 0)} бесплатно` : "Форма Pro ответит, что такого кода нет"}</span>
                            </div>
                            <div className="category-card-toggle static"><i /></div>
                        </div>

                        <div onClick={this.save} className={`organization-details-button sticky ${saving ? "disabled" : ""}`}>
                            {saving ? <LoadingOutlined /> : (id ? "Сохранить" : "Добавить промокод")}
                        </div>

                    </div>
                }

            </Modal>
        )
    }
}

export default PromoForm
